import { BASE_URLS, CLIENT_IDS, REDIRECT_URLS } from 'stash/constants/authParams';
import { getCookie } from 'stash/utils/cookies';
import { DEVICE_ID_COOKIE_NAME } from '../../constants/session';

export const buildAuthRedirect = (
	env,
	stateParam,
	codeChallenge,
	nudataQueryParams,
	redirect
) => {
	const baseUrl = BASE_URLS[env];
	const clientId = CLIENT_IDS[env];
	const redirectUrl = REDIRECT_URLS[env];
	const deviceId = getCookie(DEVICE_ID_COOKIE_NAME);
	const clientVersionParam =
		'&client_version=stash-invest-web' + encodeURIComponent(`/${window.Stash.version}`);

	return (
		baseUrl +
		`/authorize?client_id=${clientId}&redirect_uri=${redirectUrl}&state=${stateParam}&response_type=code&code_challenge=${codeChallenge}&code_challenge_method=S256` +
		(deviceId ? `&known_device_id=${deviceId}` : ``) +
		nudataQueryParams +
		(redirect ? `&r=${redirect}` : ``) +
		clientVersionParam
	);
};
